import React, {Component} from 'react';
import {Translation} from 'react-i18next';

import CareGuideHelperForm from '../containers/CareGuideHelperFormContainer';
import DocumentHead from '../../../elements/components/DocumentHead';
import Logger from '../../../../../lib/Logger';

class CareGuideHelperEditScreen extends Component {

  scrollToTop = () => {
    Logger.log('debug', `CareGuideHelperEditScreen.scrollToTop()`);
    if (typeof window !== 'undefined') {
      setTimeout(() => window.scrollTo(0, 0), 100);
    }
  }

  render() {
    return (
      <Translation>{(t) => 
        <div>
          <DocumentHead title={t('care_guide_helper_route_edit')} />
          <CareGuideHelperForm id={this.props.match.params.id} />
        </div>
      }</Translation>
    )
  }

  /* LIFECYCLE EVENTS */

  componentDidMount() {
    this.scrollToTop();
  }
}

export default CareGuideHelperEditScreen;

Logger.log('silly', `CareGuideHelperEditScreen loaded.`);
